import { action } from 'satcheljs';
import { EntityCommand } from 'owa-graph-schema';
import type { OwaNovaAction, OwaNovaActionInput } from '../types';

export const onMessageExtensionTrigger = action<
    OwaNovaActionInput,
    OwaNovaAction<'MessageExtension'>
>('onMessageExtensionTrigger', (command: EntityCommand) => {
    return { kind: 'MessageExtension', command };
});
